import React from 'react';
import { Selector } from './Selector/Selector';
export const SubtitlesSelector = ({ visible, onBackButtonClick }) => {
    const options = [
        {
            value: 'ua',
            displayText: 'Ukrainian',
        },
        {
            value: 'en',
            displayText: 'English',
        },
    ];
    return (React.createElement(Selector, { visible: visible, onBackButtonClick: onBackButtonClick, options: options, onSelect: () => { }, selectedValue: "ua", backButtonText: "Quality" }));
};
//# sourceMappingURL=SubtitlesSelector.js.map